module.exports = __webpack_public_path__ + "static/media/15.dedd3e0e.jpg";